import styled from "styled-components";

export const InternetStyle=styled.div`

  text-align: center;
  font-size: 2vh;
  font-weight: 600;
  margin-bottom: 20px;
  color: red;
  

`